import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RequestHandlerService, RequestOptionsModel } from "bnsights-utilities-library";
import { WFActivityModel } from "../models/WorkflowModels/WFActivityModel";

@Injectable({
    providedIn: 'root'
})
export class WorkflowActivityService {
    ApiUrl = "/api/admin/WorkflowActivity/"
    constructor(private http: RequestHandlerService) {
    }

    Loaddropdowns() {
       
        return this.http.get( this.ApiUrl + 'Loaddropdowns');
    }

    AddWorkflowActivity( AddModel: WFActivityModel) {
        return this.http.post( this.ApiUrl + 'AddWorkflowActivity', AddModel);
    }

    EditActivity(EditModel:WFActivityModel) {
      
        return this.http.post( this.ApiUrl + 'EditActivity', EditModel);
    }
  
}